export default {
  site: {
    name: '升学考试网',
    welcome: '欢迎访问升学考试网',
  },
  nav: {
    home: '首页',
    news: '新闻资讯',
    exam: '考试动态',
    policy: '政策解读',
    resource: '学习资源',
    category: '分类',
    search: '搜索',
    feedback: '反馈',
    menu: '菜单',
  },
  article: {
    title: '标题',
    content: '内容',
    publishedAt: '发布时间',
    source: '来源',
    views: '阅读量',
    related: '相关推荐',
    featured: '置顶推荐',
    latest: '最新资讯',
    noArticles: '暂无文章',
  },
  category: {
    gaokao: '高考',
    zhongkao: '中考',
    kaoyan: '考研',
    gongwuyuan: '公务员考试',
    zhiye: '职业资格考试',
    yingyu: '英语考试',
    liuxue: '留学考试',
  },
  search: {
    title: '搜索',
    placeholder: '输入关键词搜索...',
    resultCount: '共找到 {count} 条结果',
    noResult: '未找到相关结果',
  },
  feedback: {
    name: '姓名',
    email: '邮箱',
    content: '反馈内容',
    submit: '提交',
    success: '提交成功，感谢您的反馈！',
    fail: '提交失败，请稍后重试',
    namePlaceholder: '请输入您的姓名',
    emailPlaceholder: '请输入您的邮箱',
    contentPlaceholder: '请输入您的反馈内容',
    description: '如果您有任何建议或问题，请通过以下表单告诉我们，我们会尽快回复。',
  },
  common: {
    loading: '加载中...',
    loadMore: '加载更多',
    backHome: '返回首页',
    copyright: '版权所有',
    notFound: '页面未找到',
  },
}
